import { TOrganisation } from '@answerr/types';
import { ImageUploadResponse } from '../types/common.types';
import { CreateOrganisationResponse, OrganisationsResponse } from '../types/organisation.types';
import { UserChatDataResponse, UserChatListInput, UserListInput, UserListResponse } from '../types/user.types';
import http from '../utils/http-common';

const createOrganisation = (data: TOrganisation) => {
  return http.post<CreateOrganisationResponse>('/admin/organisation/create-organisation', data);
};

const getOrganisations = () => {
  return http.get<OrganisationsResponse>('/admin/organisation/get-organisations');
};

const getOrganisationById = (id: string) => {
  return http.post<CreateOrganisationResponse>('/admin/organisation/get-organisation', {organisationId: id});
};

const updateOrganisation = (data: TOrganisation) => {
  return http.put<CreateOrganisationResponse>('/admin/organisation/update-organisation', data);
};

const deleteOrganisation = (data: TOrganisation) => {
  return http.put<CreateOrganisationResponse>('/admin/organisation/delete-organisation', data);
};

const updateImage = (data: FormData) => {
  return http.post<ImageUploadResponse>(`/admin/organisation/image`, data);
};

const getOrgUsers = (data: UserListInput) => {
  return http.post<UserListResponse>(`/admin/organisation/users`, data)
}

const getOrgUserChatData = (data: UserChatListInput) => {
  return http.post<UserChatDataResponse>('/admin/organisation/user-chat-data', data);
};

const OrganisationsService = {
  createOrganisation,
  getOrganisations,
  getOrganisationById,
  updateOrganisation,
  deleteOrganisation,
  updateImage,
  getOrgUsers,
  getOrgUserChatData
};

export default OrganisationsService;